<app-dialog
  [headerLabel]="
    ((isKIC$ | async) ? 'LABEL.CHARGE_A_CARD' : 'LABEL.ADD_PAYMENT') | translate
  "
  [primaryActionText]="'ACTION.ADD_PAYMENT' | translate"
  [secondaryActionText]="'ACTION.CANCEL' | translate"
  [dialogType]="dialogType"
  [trackingObject]="trackingObject"
  [trackingScreenName]="trackingScreenName"
  [primaryActionTapped]="addPaymentAction"
  [primaryActionTrackingAdditionalProperties]="
    addPaymentActionAdditionalProperties
  "
  [secondaryActionTapped]="cancelAction"
  [hideActions]="isKIC$ | async"
  (onPrimaryAction)="onAddPayment()"
  (onDialogClose)="dialogClosed()"
  [ngSwitch]="isKIC$ | async"
>
  <div
    *ngSwitchCase="true"
    id="kic-dialog"
    [ngClass]="{ 'large-kic-dialog': showLargeKicDialog$ | async }"
  >
    <iframe
      *ngIf="terminalUrl && !isKicEnablingPayment; else elseBlock"
      class="kic-iframe"
      [attr.src]="terminalUrl"
      (load)="onKICLoad()"
    >
    </iframe>

    <ng-template #elseBlock>
      <div class="kic-enabling-payment">
        <app-icon [icon]="loadingSpinnerIcon"></app-icon>

        <p class="kic-enabling-payment-message">
          {{ 'LABEL.TURNING_ON_PAYMENT' | translate }}
        </p>
      </div>
    </ng-template>
  </div>

  <div
    *ngSwitchDefault
    id="manual-payment-dialog"
    data-e2e-id="manual-payment-dialog"
  >
    <button
      *ngIf="showKICButton$ | async"
      type="button"
      class="charge-card-action"
      (click)="chargeCard()"
    >
      {{ 'ACTION.CHARGE_A_CARD' | translate }}
    </button>

    <app-form-master *ngIf="form" [form]="form" class="form-content">
      <app-toggle-field
        *ngIf="calculationResult?.outstandingBalance > 0"
        [label]="'LABEL.MARK_AS_FULLY_PAID' | translate"
        class="form-row"
        fieldId="fully_paid_field"
        toggleLabelE2eId="manual-payment-fully-paid-field"
        [fieldControl]="form.get(formKeys.FULLY_PAID)"
        [trackingObject]="trackingObject"
        trackingIdentifier="mark_fully_paid"
        [trackingScreenName]="trackingScreenName"
      >
      </app-toggle-field>

      <app-currency-field
        [label]="'LABEL.AMOUNT' | translate"
        class="form-row"
        fieldId="amount_field"
        e2eId="manual-payment-amount-field"
        [currencyCode]="currencyCode"
        [locale]="locale"
        [formControl]="form.get(formKeys.AMOUNT)"
      >
      </app-currency-field>

      <app-input-field
        [label]="'LABEL.METHOD' | translate"
        class="form-row"
        fieldId="method_field"
        e2eId="manual-payment-method-field"
        [fieldControl]="form.get(formKeys.METHOD)"
        [placeholder]="'PLACEHOLDER.ENTER_METHOD' | translate"
        [options]="methodOptions"
        [maxlength]="100"
      >
      </app-input-field>

      <app-date-picker-field
        [label]="'LABEL.DATE' | translate"
        class="form-row"
        fieldId="date_field"
        [formControl]="form.get(formKeys.DATE)"
      >
      </app-date-picker-field>

      <app-textarea-field
        [label]="'LABEL.DETAILS' | translate"
        class="form-row"
        fieldId="note_field"
        textareaE2eId="manual-payment-note-field"
        [fieldControl]="form.get(formKeys.NOTE)"
        [placeholder]="'PLACEHOLDER.ADD_DETAILS' | translate"
        [maxlength]="1000"
      >
      </app-textarea-field>

      <app-toggle-field
        class="send-receipt-toggle form-row"
        [label]="'LABEL.SEND_RECEIPT' | translate"
        fieldId="send_receipt_field"
        [icon]="featureHighlightIcon"
        [fieldControl]="form.get(formKeys.SEND_RECEIPT)"
        [trackingObject]="trackingObject"
        trackingIdentifier="payment_receipts"
        [trackingScreenName]="trackingScreenName"
        (onClickIcon)="showFeatureHighlightDialog()"
      >
      </app-toggle-field>
    </app-form-master>

    <button
      type="button"
      class="preview-receipt-action"
      trackable
      [trackingObject]="trackingObject"
      [trackingAction]="sendPreviewAction"
      (click)="onPreviewReceipt()"
    >
      {{ 'ACTION.PREVIEW_RECEIPT' | translate }}
    </button>
  </div>
</app-dialog>
